<div
  class="inline-block h-[1.5em] w-[1.5em] animate-spin rounded-full border-[0.1875em] border-solid border-current border-r-transparent align-middle"
  role="status"
/>
